module.exports = __webpack_public_path__ + "img/Pants.546ca073.svg";